import { render, staticRenderFns } from "./PoliciesChooser.vue?vue&type=template&id=89acff2c&scoped=true&"
import script from "./PoliciesChooser.vue?vue&type=script&lang=ts&"
export * from "./PoliciesChooser.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89acff2c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89acff2c')) {
      api.createRecord('89acff2c', component.options)
    } else {
      api.reload('89acff2c', component.options)
    }
    module.hot.accept("./PoliciesChooser.vue?vue&type=template&id=89acff2c&scoped=true&", function () {
      api.rerender('89acff2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/policies/PoliciesChooser.vue"
export default component.exports